<template>
    <div :class="topBarClass">
        <template v-if="!isLoading">
            <div
                class="Topbar__bar"
                @click="toggleOpen"
            >
                <div
                    v-if="activeSubheader"
                    class="Topbar__subheader-container"
                >
                    <span class="Topbar__subheader">
                        {{ activeSubheader.header }}
                    </span>
                </div>
                <RPNavTab
                    :label="activeTab"
                    :is-active="true"
                />
                <StreamlineIcon
                    class="Topbar__arrow-icon"
                    fill="#768592"
                    :icon="ArrowIcon"
                    :size="8"
                />
            </div>
            <!--
                TODO: convert to `router-link` or wrapper
                @event navigate
                -->
            <RPSidebar
                :class="`Topbar__dropdown--${open ? 'open' : 'close'}`"
                :tabs="tabs"
                :dynamic-tab="dynamicTab"
                :disabled-tabs="disabledTabs"
                :active-tab="activeTab"
                @navigate="to => $emit('navigate', to)"
            />
        </template>
    </div>
</template>
<script>
import RPNavTab from 'components/Basic/Buttons/RPNavTab.vue';
import RPSidebar from './RPSidebar.vue';
import has from 'lodash/has';
import stat from 'status/index';
import statusBuilder from 'status/statusBuilder';
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {ArrowUp1, ArrowDown1} from "@reviewpush/streamline-bold/lib/arrows-diagrams/Arrows";

export default {
    name: 'RPTopbar',
    components: {
        RPNavTab,
        RPSidebar,
        StreamlineIcon
    },
    props: {
        /**
         * See `RPSidebar` for prop details
         */
        tabs: {
            type: Array,
            required: true,
        },
        /**
         * See `RPSidebar` for prop details
         */
        disabledTabs: {
            type: Array,
            default: () => ([]),
        },
        /**
         * See `RPSidebar` for prop details
         */
        dynamicTab: {
            type: String,
            default: '',
        },
        /**
         * See `RPSidebar` for prop details
         */
        activeTab: {
            type: String,
            required: true,
        },
        status: {
            type: String,
            default: stat.STANDBY,
        },
    },
    data(){
        return {
            open: false,
        };
    },
    computed: {
        ArrowIcon(){
            return this.open
                ? ArrowUp1
                : ArrowDown1;
        },
        isLoading(){
            return this.status === stat.LOADING;
        },
        topBarClass(){
            return statusBuilder('Topbar', this.status);
        },
        activeSubheader(){
            return this.tabs.find(tab => {
                return has(tab, 'header')
                    && ((has(tab,'subTabs') && tab.subTabs.find(s => s.to.name === this.activeTab))
                        || (has(tab,'subsections') && tab.subsections.find(s => s.to.name === this.activeTab)));
            });
        },
    },
    mounted(){
        document.addEventListener('click', this.close);
    },
    destroyed() {
        document.removeEventListener('click', this.close);
    },
    methods: {
        toggleOpen(){
            this.open = !this.open;

        },
        close(e) {
            if(!this.$el.contains(e.target)) {
                this.open = false;
            }
        }
    }
};
</script>
<style lang="scss">
    .Topbar {
        position: relative;
        min-width: 7rem;

        @include loading(2rem, 7rem);

        &__bar {
            min-width: 7rem;
            cursor: pointer;
            padding: 0.5rem;
            background: $white;
            border-radius: 4px;
            box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08);
            display: flex;
            justify-content: space-evenly;
            align-items: center;
        }
        &__subheader {
            &-container{
                align-items: center;
                margin: auto .5rem auto 0;
            }

            &-icon{
                margin: auto 0.25rem auto 0;
                height: 1rem;
                width: 1rem;
                stroke: $grey-200;
                stroke-width: 2px;
                fill: transparent;
            }
        }
        &__arrow-icon{
            margin-left: 1rem;
        }
        &__dropdown {
            &--open {
                right: 0;
                width: fit-content;
                position: absolute;
                z-index: 999;
            }
            &--close {
                display: none;
            }
        }

    }
</style>

<docs>
```vue
<RPTopbar
    activeTab="SomeRouteName"
    :tabs="[
        {
            header: 'First Tab Header',
            subTabs: [
                {
                    label: 'Link One (A Subtab)',
                    to: {
                        name: 'SomeSubRoute'
                    }
                }
            ]
        },
        {
            label: 'Link Two (currently active)',
            to: {
                name: 'SomeRouteName'
            },
        },
        {
            label: 'Link Three',
            to: {
                name: 'AnotherRouteName'
            },
        }
    ]"
>
</RPTopbar>
```
</docs>
